/**
 * angular2-cookie - Implementation of Angular 1.x $cookies service to Angular 2
 * @version v1.2.6
 * @link https://github.com/salemdar/angular2-cookie#readme
 * @license MIT
 */
"use strict";
var base_cookie_options_1 = require('./services/base-cookie-options');
exports.BaseCookieOptions = base_cookie_options_1.BaseCookieOptions;
exports.CookieOptions = base_cookie_options_1.CookieOptions;
var cookies_service_1 = require('./services/cookies.service');
exports.CookieService = cookies_service_1.CookieService;

//# sourceMappingURL=services.js.map



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src727013012/src/~/angular2-cookie/services.js
// module id = etf1
// module chunks = 6